/* eslint-disable */
import Store from './db';

const cachedStore = {};
class IStore {
  constructor(prefix, store = Store) {
    this.prefix = prefix;
    this.store = store;
  }

  set(key, value) {
    this.store.set(`${this.prefix}_${key}`, value);
  }

  get(key, defaultValue = null) {
    return this.store.get(`${this.prefix}_${key}`, defaultValue);
  }
}

export default {
  create(prefix, store) {
    if (cachedStore[prefix]) {
      return cachedStore[prefix];
    }
    cachedStore[prefix] = new IStore(prefix);
    return cachedStore[prefix];
  },
};
// 使用
// import storeCreator from '@/utils/store-creator';
// const store = storeCreator.create('G');
// store.set('UserInfo', {name: 'abc'});
// store.get('UserInfo'); // {name: 'abc'}
// store.get('UserInfoF', {name: '123'}); {name: '123'}
